import { defineMessages } from 'react-intl'

import { SERVICE_TYPE } from './constants'

export const serviceTypeMessages = defineMessages({
  [SERVICE_TYPE.L]: {
    id: 'serviceType.luxury',
    defaultMessage: 'Luxury'
  },
  [SERVICE_TYPE.P]: {
    id: 'serviceType.primera',
    defaultMessage: 'Primera'
  },
  [SERVICE_TYPE.E]: {
    id: 'serviceType.economic',
    defaultMessage: 'Economic'
  }
})
